import { DOCUMENT_FILE_TYPES, EstimateFile } from "@/enums/estimate-file";
import type { Estimation } from "@/interfaces/estimation.interface";

export const getDocumentationCount = (estimateData: Estimation) => {
  let images = 0;
  let others = 0;
  let tics = 0;

  const links = estimateData.links?.length ?? 0;
  const notes = (estimateData.scopeNoteObjects?.length ?? 0) + (estimateData.notes?.length ?? 0);

  const files = estimateData.files || [];
  const totalFiles = files.length + links + notes;

  for (const file of files) {
    if (file.fileType === EstimateFile.IMAGE) images++;
    else if (file.fileType === EstimateFile.TIC) tics++;
    else if (DOCUMENT_FILE_TYPES.includes(file.fileType as EstimateFile)) others++;
  }

  return {
    tics,
    images,
    others,
    links,
    notes,
    totalFiles,
  };
};
